export type NoticeMatch = {
  id: number;
  revisionId: string;
  path: string;
  contents: string;
  copyrights?: string[];
  createdAt: Date;
  updatedAt: Date;
  corrected: boolean;
  ignored: boolean;
}

export enum NoticeMatchCorrectionType {
  Ignored = 'ignored',
  Edited = 'edited',
  Added = 'added',
  RemoveIgnored = 'remove_ignored',
  RemoveAdded = 'remove_added',
}

export type NoticeMatchCorrectionRequest = {
  correctionType: NoticeMatchCorrectionType;
  path: string;
  contents?: string;
  copyrights?: string[];
}
